// 軽量 sparkline (SVG ベース、 Observable Plot は重いのでこちらを使用)
// width / height / values から最低限の折れ線を描く。
interface Props {
  values: (number | null)[];
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
  showLast?: boolean;
}

export function Sparkline({
  values,
  width = 120,
  height = 32,
  stroke = "#0ea5e9",
  fill = "rgba(14,165,233,0.08)",
  showLast = false,
}: Props) {
  const nums = values.map((v) => (v == null || !Number.isFinite(v) ? null : v));
  const valid = nums.filter((v): v is number => v != null);
  if (valid.length < 2) return <svg width={width} height={height} />;
  const min = Math.min(...valid);
  const max = Math.max(...valid);
  const range = max - min || 1;
  const stepX = width / (nums.length - 1);

  const pts: string[] = [];
  const areaPts: string[] = [`0,${height}`];
  nums.forEach((v, i) => {
    if (v == null) return;
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    pts.push(`${x},${y}`);
    areaPts.push(`${x},${y}`);
  });
  areaPts.push(`${width},${height}`);

  let lastIdx = -1;
  for (let i = nums.length - 1; i >= 0; i--) {
    if (nums[i] != null) { lastIdx = i; break; }
  }
  const lastX = lastIdx * stepX;
  const lastY = lastIdx >= 0 && nums[lastIdx] != null
    ? height - ((nums[lastIdx]! - min) / range) * (height - 4) - 2
    : 0;

  return (
    <svg width={width} height={height} className="block">
      <polygon points={areaPts.join(" ")} fill={fill} />
      <polyline points={pts.join(" ")} fill="none" stroke={stroke} strokeWidth={1.4} strokeLinejoin="round" strokeLinecap="round" />
      {showLast && lastIdx >= 0 && (
        <circle cx={lastX} cy={lastY} r={2.2} fill={stroke} />
      )}
    </svg>
  );
}
